import React from "react";

/** Figma hand-coins — outer 40×40, leaf inset ~8.33% (node 2181:7665) */
const HandCoinsIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-10 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[8.33%_8.22%_8.33%_8.33%]">
                <svg
                    className={className ?? "block size-full"}
                    viewBox="0 0 35.3782 35.3333"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...rest}
                >
                    <path
                        d="M16 22.6667H19.3333C20.2174 22.6667 21.0652 22.3155 21.6904 21.6904C22.3155 21.0652 22.6667 20.2174 22.6667 19.3333C22.6667 18.4493 22.3155 17.6014 21.6904 16.9763C21.0652 16.3512 20.2174 16 19.3333 16H14.3333C13.3333 16 12.5 16.3333 12 17L2.66667 26M9.33333 32.6667L12 30.3333C12.5 29.6667 13.3333 29.3333 14.3333 29.3333H21C22.8333 29.3333 24.5 28.6667 25.6667 27.3333L33.3333 20C33.9765 19.3922 34.3518 18.5538 34.3769 17.6693C34.4019 16.7847 34.0745 15.9265 33.4667 15.2833C32.8589 14.6402 32.0205 14.2648 31.1359 14.2398C30.2514 14.2148 29.3932 14.5422 28.75 15.15L21.75 21.65M1 24.3333L11 34.3333M29.1667 12.6667C29.1667 15.336 27.0027 17.5 24.3333 17.5C21.664 17.5 19.5 15.336 19.5 12.6667C19.5 9.99729 21.664 7.83333 24.3333 7.83333C27.0027 7.83333 29.1667 9.99729 29.1667 12.6667ZM12.6667 6C12.6667 8.76142 10.4281 11 7.66667 11C4.90524 11 2.66667 8.76142 2.66667 6C2.66667 3.23858 4.90524 1 7.66667 1C10.4281 1 12.6667 3.23858 12.6667 6Z"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    );
};

export default HandCoinsIcon;
